module.exports = __webpack_public_path__ + "img/gc_country_flag_sg.df06c7e6.svg";